export default __webpack_public_path__ + "static/media/phone.73d57041.svg";